import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as RightArrow } from "../../../assets/Icons/rightArrow.svg";
import ShowCard from "../../../Components/ShowCard/ShowCard";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import { Link, useNavigate } from "react-router-dom";
import { useWindowWidth } from "@react-hook/window-size";
import { useSelector } from "react-redux";
import MagazineCard from "../../../Components/MagazineCard/MagazineCard";
import ShortsCard from "../../../Screens/Shorts/ShortsCard";
import Translate from "../../../Components/Multilanguage/Translate";
import { navigateToCategory, rowItemCount, translateText } from "../../../utils/utils";
import { useTranslation } from "react-i18next";
// import ConfirmationPopup from "../../../Components/ConfirmationPopup/ConfirmationPopup";
// import Util from "./util"

const Categories = ({ data, fromFavoritesScreen = false }) => {
  const { t } = useTranslation();
  const languageModal = useSelector((state) => state?.languageModal?.value);
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const isRTL = useSelector((state) => state?.rtl?.isRTL);
  const windowSize = useWindowWidth();
  const [rowItemCountNumber, setRowItemCountNumber] = useState(5);
  const template = projectInfo?.projectConfig?.config?.TEMPLATE;
  const count = data?.shows?.length;
  const playlistId = data?.playlist_id;
  const theme =projectInfo?.projectConfig?.config?.THEME ;
  const [displayedData, setDisplayedData] = useState(data?.shows || []);
  const [showConfirm, setShowConfirm] = useState(false);
  // const [isHoveringCategory, setIsHoveringCategory] = useState(false);
  // const [isTouchDevice, setIsTouchDevice] = useState(false);
  
  // const util = Util();

  // Detect touch device
  // useEffect(() => {
  //   const checkTouchDevice = () => {
  //     setIsTouchDevice('ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0);
  //   };
  //   checkTouchDevice();
  // }, []);

  // const handleDelete = async () => {
  //   try {
  //     const response = await util.playlistDeleteHandler(playlistId);
  //     if (response === true) {
  //       setShowConfirm(false);
  //     }
  //   } catch (err) {
  //     setShowConfirm(false);
  //   }
  // };

    useEffect(() => {
      setDisplayedData(data?.shows || []);
    }, [data?.shows]);

    useEffect(() => {
      if (windowSize > 1200){
        if (data?.type === 'SHORTS'){
          const baseCount = projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT || 5;
          setRowItemCountNumber(baseCount + 1);
        }
      }
      if (windowSize > 980) {
      const newClass = projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT
        ? rowItemCount(projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT)
        : "rowCount5";
      setRowItemCountNumber(parseInt(newClass.replace(/\D/g, ''), 10));
          if (data?.type === 'FASTCHANNELS'){
            setRowItemCountNumber(9);
          }
          if (data?.type === 'SHORTS'){
            const baseCount = projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT || 4;
            setRowItemCountNumber(baseCount + 1);
          }
        } else {
          if (windowSize > 767){
            setRowItemCountNumber(3);
          } else if (windowSize > 479){
            setRowItemCountNumber(2);
          } else if (windowSize > 319){
            setRowItemCountNumber(1);
          }
          if (data?.type === 'FASTCHANNELS'){
            if (windowSize > 767){
              setRowItemCountNumber(4);
            } else if (windowSize > 319){
              setRowItemCountNumber(3);
            }
          }
        }
      if (data?.type === 'FASTCHANNELS'){
        if (windowSize > 767){
          setRowItemCountNumber(4);
        } else if (windowSize > 319){
          setRowItemCountNumber(3);
        }
      }
    }, [projectInfo, windowSize]);

     
  if (isRTL && count > rowItemCountNumber) {
    displayedData = [...data?.shows].reverse();
  }

  const navigate = useNavigate();
  const thumbnailOrientation = data?.thumbnail_orientation ? data?.thumbnail_orientation : projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION;

  const handleRemoveItem = (videoIdToRemove) => {
    setDisplayedData(prevData => prevData.filter(item => item.video_id !== videoIdToRemove));
  };
  return (
    <div className={`categoriesContainer ${isRTL ? (count > rowItemCountNumber ? "ltr" : windowSize < 980 ? "rtl" : "rtl" ) : ""}`}
      role="region"
      aria-label="Categories Section">
      <div className="wrapper">
        <div
          className={`categoryNameContainer ${data?.show_all_needed ? 'link' : ''}`}
          onClick={data?.show_all_needed ? () => navigateToCategory(navigate, data, thumbnailOrientation) : undefined}
          role={data?.show_all_needed ? "button" : undefined}
          tabIndex={data?.show_all_needed ? 0 : undefined}
          aria-label={data?.show_all_needed ? `View all ${data?.category_name}` : undefined}
          onKeyDown={data?.show_all_needed ? (e => { if (e.key === 'Enter' || e.key === ' ') navigateToCategory(navigate, data, thumbnailOrientation); }) : undefined}
          // onMouseEnter={() => setIsHoveringCategory(true)}
          // onMouseLeave={() => setIsHoveringCategory(false)}
        >
          <h1>{data?.category_name}</h1>
          {/* {fromFavoritesScreen && playlistId !== 0 && (isTouchDevice || isHoveringCategory) && (
            <svg
              onClick={() => { setShowConfirm(true); }}
              onMouseEnter={(e) => e.target.style.stroke = 'var(--button-hover)'}
              onMouseLeave={(e) => e.target.style.stroke = 'var(--button-color)'}
              viewBox="0 0 24 24"
              fill="none"
              aria-label="Delete playlist"
            >
              <path d="M10 12V17" stroke="var(--button-color)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M14 12V17" stroke="var(--button-color)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M4 7H20" stroke="var(--button-color)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M6 10V18C6 19.6569 7.34315 21 9 21H15C16.6569 21 18 19.6569 18 18V10" stroke="var(--button-color)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke="var(--button-color)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          )} */}
          { data?.show_all_needed && (template == 'TEMPLATE_9' ? <span> {translateText(languageModal, t, 'show_all')}</span> : <RightArrow />)}
        </div>
        <div className="itemsContainer">
          <Swiper
            key={isRTL ? (count > rowItemCountNumber ? "ltr" : windowSize < 980 ? "rtl" : "rtl" ) : ""}
            modules={[Navigation]}
            spaceBetween={10}
            slidesPerView={6}
            navigation={true}
            watchSlidesProgress
            loop={false}
            initialSlide={(isRTL && count > rowItemCountNumber) ? count - 1 : 0}
            className={`${thumbnailOrientation === "PORTRAIT" ? "portrait" : "landscape"} ${theme === "LIGHT" ? "white-bg" : ""}`}
            breakpoints={{
              320: {
                slidesPerView: thumbnailOrientation === "PORTRAIT" ? 2 : data?.type == 'FASTCHANNELS' ? 3 : 1,
                spaceBetween: 5,
              },
              480: {
                slidesPerView: thumbnailOrientation === "PORTRAIT" ? 3 : data?.type == 'FASTCHANNELS' ? 3 : 2,
                spaceBetween: 5,
              },
              768: {
                slidesPerView: thumbnailOrientation === "PORTRAIT" ? 4 : data?.type == 'FASTCHANNELS' ? 4 : 2,
                spaceBetween: 10,
              },
              980: {
                  slidesPerView: data?.type === 'SHORTS' ? (projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT ? Number(projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT) + 1 : 5) : data?.type == 'FASTCHANNELS' ? 9 : thumbnailOrientation === "PORTRAIT" ? 4 : projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT ? projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT : ( projectInfo?.projectConfig?.pubid === 50134 ? thumbnailOrientation === 'PORTRAIT' ? 6 : 4 : thumbnailOrientation === "PORTRAIT" ? 7 : 4),
                  spaceBetween: 10,
                },
              1200: {
                  slidesPerView: data?.type === 'SHORTS' ? (projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT ? Number(projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT) + 1 : 6) : data?.type == 'FASTCHANNELS' ? 9 : projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT ? projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT : ( projectInfo?.projectConfig?.pubid === 50134 ? thumbnailOrientation === 'PORTRAIT' ? 6 : 4 : thumbnailOrientation === "PORTRAIT" ? 7 : 4),
                  spaceBetween: data?.type === 'SHORTS' ? 10 : 20,
                },
            }}
            aria-label="Categories Carousel"
          >
            {displayedData?.map((item, index) => (
              <SwiperSlide key={index} aria-label={`Category Slide ${index + 1}`}> 
                <div className={data?.type === "SHORTS" ? "shortsCardContainer" : "show"}>

                  {
                    data?.type === "MAGAZINES" ? (
                      <MagazineCard
                        data={item}
                        url={data.url}
                        metaData={true}
                        cardHover={true}
                      />
                    ) : data?.type === "SHORTS" ? (
                      <ShortsCard
                        data={item}
                        season={false}
                        metaData={true}
                        type={data?.type}
                        vanityUrl={item?.vanity_url}
                      />
                    ) : (
                      <ShowCard
                        data={item}
                        season={false}
                        metaData={true}
                        type={data?.type}
                        thumbnailOrientation={thumbnailOrientation}
                        displayedData={displayedData}
                        onRemove={handleRemoveItem}
                        fromFavoritesScreen={fromFavoritesScreen}
                        playlistId={playlistId}
                      />
                    )
                  }

                </div>

              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        {/* <ConfirmationPopup
          isOpen={showConfirm}
          onClose={() => setShowConfirm(false)}
          onContinue={handleDelete}
          questionText={translateText(languageModal, t, 'delete_from_playlist_placeholder').replace('NAME', data?.category_name)}
          continueText={translateText(languageModal, t, 'delete')}
          cancelText={translateText(languageModal, t, 'cancel')}
        /> */}
      </div>
    </div>
  );
};

export default Categories;
